import React from 'react';
import { Card } from './ui/card';
import { portfolioData } from '../data/mock';

const Skills = () => {
  const { skills } = portfolioData;

  const allSkills = [
    ...skills.languages.map(s => ({ ...s, category: 'Languages' })),
    ...skills.frameworks.map(s => ({ ...s, category: 'Frameworks' })),
    ...skills.cloud.map(s => ({ ...s, category: 'Cloud' })),
    ...skills.databases.map(s => ({ ...s, category: 'Databases' })),
    ...skills.tools.map(s => ({ ...s, category: 'Tools' })),
    ...(skills.concepts || []).map(s => ({ ...s, category: 'Core Concepts' })),
    ...(skills.ai || []).map(s => ({ ...s, category: 'AI/ML & GenAI' }))
  ];

  return (
    <section id="skills" className="section-padding">
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="section-label">Technical Expertise</span>
          <h2 className="section-title">
            Tools & <span className="text-accent">Technologies</span>
          </h2>
          <p className="section-description">
            Tools & technologies I use to build exceptional solutions
          </p>
        </div>

        {/* Minimalist Skills Grid */}
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {allSkills.map((skill, index) => (
              <div
                key={index}
                className="skill-tag"
                style={{
                  animationDelay: `${index * 0.05}s`
                }}
              >
                {skill.name}
              </div>
            ))}
          </div>

          {/* Skill Categories - Minimalist */}
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mt-20">
            <div className="text-center">
              <div className="text-4xl font-bold text-accent mb-2">3</div>
              <div className="text-sm text-muted uppercase tracking-wider">Languages</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-accent mb-2">7</div>
              <div className="text-sm text-muted uppercase tracking-wider">Frameworks</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-accent mb-2">7</div>
              <div className="text-sm text-muted uppercase tracking-wider">Cloud Tools</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-accent mb-2">3</div>
              <div className="text-sm text-muted uppercase tracking-wider">Databases</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-accent mb-2">5</div>
              <div className="text-sm text-muted uppercase tracking-wider">Dev Tools</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
